import React from 'react'
import { Link } from 'react-router-dom'

const Breadcrumbs = ({ paths }) => {
  return(
    <div className='Breadcrumbs'>
      <ol className='breadcrumb'>
        Go to: {paths.map((p,i) => <li key={`${i}-${p.name}`}><Link to={p.path}>{p.name}</Link></li>)}
      </ol>
    </div>
  )
}

export default Breadcrumbs


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/Breadcrumbs.jsx